
import { Component, Vue } from 'vue-property-decorator';
import { TeamData, teamDataArray } from '../data/team-data'
import ScrollHintArrows from '../components/ScrollHintArrowsVert.vue'

// import variables from '../styles/variables.scss'

@Component({
  components: { ScrollHintArrows }
})
export default class Team extends Vue {
  private teamData: Array<TeamData> = teamDataArray
  private teamWrapper: HTMLElement | null = null

  // ************************
  private scrollActive = false
  // ************************

  created () {
    this.teamData.forEach(td => td.imgLoaded = false)
  }

  mounted() {
    this.teamWrapper = this.$refs.teamWrapper as HTMLElement
  }

  imageLoaded(index: number) {
    // console.log('TEAM::image loaded', index)
    setTimeout(() => {
      this.teamData[index].imgLoaded = true
    }, 200)
  }

}
